exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".request-name[data-v-dd00ce58]{color:#000}.opportunity[data-v-dd00ce58]{color:#222}.request-list__link[data-v-dd00ce58]{display:inline-block;padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd00ce58","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/staff/blocks/RequestList.vue
// module id = 521
// module chunks = 0